import { NavigationButton } from "@components/common/NavigationLink";
import { DirectionsCar, Person } from "@mui/icons-material";
import { RoutePaths } from "@utils/constants/routes";

import LinksSubHeader from "..";

function InvoiceSubheader() {
  return (
    <LinksSubHeader>
      <NavigationButton
        to={`${RoutePaths.adminInvoicesDriver}/subscription`}
        includes={RoutePaths.driver}
      >
        <DirectionsCar />
        <span style={{ fontSize: "0.75rem" }}>Drivers</span>
      </NavigationButton>
      <NavigationButton
        to="https://axonaut.com/dashboard/index"
        includes={RoutePaths.client}
        isExternalLink
      >
        <Person />
        <span style={{ fontSize: "0.75rem" }}>Clients</span>
      </NavigationButton>
    </LinksSubHeader>
  );
}

export default InvoiceSubheader;
